import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { UserModel } from 'app/models/user.model';
import { ApiService } from 'app/shared/apis/api.service';
import { ErrorDialogComponent } from 'app/shared/dialogs/error-dialog/error-dialog.component';
import { of, switchMap, take } from 'rxjs';

export const CanAccessSuppliersGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router = inject(Router);
    const matDialog = inject(MatDialog);

    return ApiService.userCurrent.pipe(
        take(1),
        switchMap((user: UserModel) => {
            if (user?.isAdmin) {
                return of(true);
            }
            if (user?.canAccessSuppliers) {
                return of(true);
            }

            matDialog.open(ErrorDialogComponent, {
                data: {
                    message:
                        'Você não tem permissão para acessar fornecedores. Entre em contato com o administrador.',
                },
            });

            return of(router.parseUrl('/wallet'));
        }),
    );
};
